import { parseJwt } from '../utils/jwtDecoder';
import { getItem } from '../utils/authStorage';
import { fetchWithAuthRetry, getAuthHeaders, ensureValidToken } from '../utils/helpers';

/**
 * Fetch site_data records from /api/construction/projects/{numericId}/site-data
 * @param {number} numericId - Numeric project ID from DB (1, 2, 3)
 * @param {string} category  - Category filter ('Earth', 'Material', etc.)
 * @returns {Promise<Array>}
 */
export async function fetchSiteData(numericId, category) {
  if (!numericId) return [];

  const endpoint = `/api/construction/projects/${numericId}/site-data?category=${encodeURIComponent(category || '')}`;

  try {
    await ensureValidToken();
    const token = getItem('accessToken');
    const payload = token ? parseJwt(token) : null;
    const tenantId = payload?.tenant_id || '';

    const headers = {
      ...getAuthHeaders(),
      ...(tenantId ? { 'X-Tenant-Id': tenantId } : {}),
    };

    const response = await fetchWithAuthRetry(endpoint, { headers });
    if (response.ok) {
      const json = await response.json();
      if (json && Array.isArray(json.records)) return json.records;
      if (json && Array.isArray(json.data)) return json.data;
      if (Array.isArray(json)) return json;
    } else {
      console.warn(`GET ${endpoint} → HTTP ${response.status}`);
    }
  } catch (err) {
    console.error(`fetchSiteData error (${endpoint}):`, err);
  }

  return [];
}
